import { render } from "./Astronaut.vue?vue&type=template&id=06f413fe"
import script from "./Astronaut.vue?vue&type=script&lang=js"
export * from "./Astronaut.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__